import React from 'react';
import { List, Item } from 'semantic-ui-react';

import { findDocumentType } from '../../../../../utils/documentTypes';
import parseServerChangeLog from './parseServerLog';

const DocumentEdited = ({ details }) => {
  const { changeset, documentUrl } = parseServerChangeLog(details);
  return changeset ? (
    <List>
      {Object.keys(changeset).map((change, i) => (
        <List.Item key={i}>
          <Item>
            <Item.Image
              style={{ cursor: 'pointer' }}
              size="tiny"
              src={documentUrl}
            />
            <Item.Content>
              <Item.Meta>
                {change}:{' '}
                {findDocumentType(changeset[change][0]).text || 'null'} =>{' '}
                {findDocumentType(changeset[change][1]).text || 'null'}
              </Item.Meta>
            </Item.Content>
          </Item>
        </List.Item>
      ))}
    </List>
  ) : (
    details
  );
};

export default DocumentEdited;



// WEBPACK FOOTER //
// ./src/component/ClaimPage/ClaimHistory/HistoryItem/ActionTypes/DocumentEdited.js